export default __webpack_public_path__ + "static/media/store_svg3.093222ad.svg";